<template>
  <div id="calendar-menu">
    <div class="calendar-box-subheader calendar-text-center border-color-skin pc-menu-right">
      <div class="icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20" v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab1Disp }" @click="toggleCalendar('calendarTab1Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star font-white set-position-star' : foundCalendar.tab1, 'animated zoomOut fa fa-star star font-white  set-position-star' : !foundCalendar.tab1 }"></a>
        <div class="menu-icon"><img id="navpc-img1" :src="require('static/images/icon_leave.png')"></div>
        <div class="menu-text">Leave</div>
      </div>
      <div class="icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20" v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab2Disp }" @click="toggleCalendar('calendarTab2Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star font-white set-position-star' : foundCalendar.tab2, 'animated zoomOut fa fa-star star font-white  set-position-star' : !foundCalendar.tab2 }"></a>
        <div class="menu-icon"><img id="navpc-img1" :src="require('static/images/icon_appointment.png')"></div>
        <div class="menu-text">Appointment</div>
      </div>
      <div class="icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20" v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab3Disp }" @click="toggleCalendar('calendarTab3Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star font-white set-position-star' : foundCalendar.tab3, 'animated zoomOut fa fa-star star font-white set-position-star' : !foundCalendar.tab3 }"></a>
        <div class="menu-icon"><img id="navpc-img1" :src="require('static/images/icon_training.png')"></div>
        <div class="menu-text">Training</div>
      </div>
      <div class="icon-layout bg-color-skin bg-hover-color-skin-dark-10 border-color-skin-light-20" v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab4Disp }" @click="toggleCalendar('calendarTab4Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star font-white set-position-star' : foundCalendar.tab4, 'animated zoomOut fa fa-star star font-white set-position-star' : !foundCalendar.tab4 }"></a>
        <div class="menu-icon"><img id="navpc-img1" :src="require('static/images/icon_todolist.png')"></div>
        <div class="menu-text">To do list</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'calendar_menu',
  props: [ 'calendarTab1Disp', 'calendarTab2Disp', 'calendarTab3Disp', 'calendarTab4Disp', 'toggleCalendar', 'foundCalendar' ]
}
</script>

<style>
  .set-position-star{
    position: relative;
    top:8px;
  }
</style>


// WEBPACK FOOTER //
// calendar_menu_pc.vue?598ece2a